/** Workspace Member API — Faz 1.4 createApi factory. */
import {createApi} from './_factory'
import type {CommonNs, SettingNs, WorkspaceNs} from '@shared/types'

const member = createApi('member')
const workspace = createApi('workspace')

export const WorkspaceMemberApi = {
  getWorkspaceMemberList: (workspaceId: string) =>
    member.get<WorkspaceNs.Member[]>(workspaceId),
  getMemberDetails: (workspaceId: string, memberId: number) =>
    member.get<WorkspaceNs.Member>(`${workspaceId}/${memberId}`),
  changeWorkspaceMemberRole: (data: WorkspaceNs.ChangeWorkspaceMemberRoleRequest) =>
    member.post<WorkspaceNs.ChangeWorkspaceMemberRoleRequest, CommonNs.AnyResponse>('change-workspace-member-role', data),
  changeWorkspaceMemberStatus: (data: WorkspaceNs.ChangeWorkspaceMemberStatusRequest) =>
    member.post<WorkspaceNs.ChangeWorkspaceMemberStatusRequest, CommonNs.AnyResponse>('change-workspace-member-status', data),
  inviteMemberToWorkspace: (data: WorkspaceNs.InviteMembersRequest) =>
    workspace.post<WorkspaceNs.InviteMembersRequest, CommonNs.AnyResponse>('invite-members', data),
  deleteMemberFromWorkspace: (data: WorkspaceNs.RemoveWorkspaceMemberRequest) =>
    member.post<WorkspaceNs.RemoveWorkspaceMemberRequest, CommonNs.AnyResponse>('remove-member-from-workspace', data),
  updateMemberInfo: (data: SettingNs.UpdateMemberInfoRequest) =>
    member.post<SettingNs.UpdateMemberInfoRequest, CommonNs.AnyResponse>('update-member-info', data),
}
